import { formatMoney } from '@betterment/core';
import { format } from 'date-fns';

import { ForecasterProjectionChart } from '../../../../shared/components/ForecasterProjectionChart';
import { ProjectionHighlight } from '../../../../shared/components/ProjectionHighlight';
import { Disclosures, PurposeMajorPurchase } from '../../../data';

type Props = {
  purpose: PurposeMajorPurchase;
  disclosures: Disclosures;
};

export const MajorPurchaseProjection: React.FC<Props> = ({ purpose, disclosures }) => {
  const { majorPurchaseTarget: target, majorPurchaseProjection: projection } = purpose;
  const timeSeries = projection?.balanceTimeSeries;
  if (!timeSeries) return null;

  const expectedBalance = timeSeries[timeSeries.length - 1].expected;

  return (
    <>
      <ForecasterProjectionChart targetAmount={target.amount} disclosures={disclosures} timeSeries={timeSeries}>
        <ForecasterProjectionChart.Header>
          {(target.date || target.amount) && (
            <>
              {target.date && (
                <ProjectionHighlight
                  title={`Projected ${format(target.date, 'MMM yyyy')}`}
                  value={formatMoney(expectedBalance)}
                />
              )}
              {target.amount && <ProjectionHighlight title="Target balance" value={formatMoney(target.amount)} />}
            </>
          )}
        </ForecasterProjectionChart.Header>
      </ForecasterProjectionChart>
    </>
  );
};
